import React, { Fragment } from "react";
import Footer from "../../components/footer/Footer";
import Hero6 from "../../components/hero6/Hero6";
import Navbar3 from "../../components/Navbar3/Navbar3";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Logo from "../../images/logo.png";
import CompanySection from "../../components/CompanySection/CompanySection";
import WorkShowcase from "../../components/WorkShowcase/WorkShowcase";
import ReviewSection from "../../components/ReviewSection/ReviewSection";
import WelcomeSection from "../../components/WelcomeSection/WelcomeSection";
import SuccessSection from "../../components/SuccessSection/SuccessSection";
import ServicesSection from "../../components/ServicesSection/ServicesSection";
import CookiePopup from "../../components/CookiePopup/CookiePopup";

const HomePage7 = () => {
  return (
    <Fragment>
      <div
        style={{
          backgroundImage: `url('/img/homebg.jpeg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          // position: 'relative',
        }}
      >
        <Navbar3 Logo={Logo} topbarNone={"wpo-header-style-6"} />
        <Hero6 />
        <SuccessSection />
        <ServicesSection />
        <CompanySection />
        {/* <WorkShowcase/> */}
        {/* <ReviewSection/> */}
        <WelcomeSection
          title="Welcome Onboard"
          subtitle="Let's go on this technological adventure together, where the possibilities are limitless and the boundaries of invention are unbounded."
          buttonText="Contact Us"
        />
        <CookiePopup />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default HomePage7;
